let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("2dAGH")).then(() => parcelRequire('3x2ID'));